import { Directive, ElementRef } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, Validators } from '@angular/forms';

@Directive({
  selector: 'input[appEmailValidate]',
  providers: [{provide: NG_VALIDATORS, useExisting: EmailValidateDirective, multi: true}]
})
export class EmailValidateDirective implements Validator {

  constructor(private el: ElementRef) { }

  validate(c: AbstractControl): { [key: string]: any; } {
    if ('validity' in this.el.nativeElement) {
      if (this.el.nativeElement.validity.valid === false) {
        if (this.el.nativeElement.validity.typeMismatch) {
          return { typeMismatch: true };
        }
      }
    }

    return Validators.email(c);
  }
}
